import FastClick from 'fastclick';
import './styles.scss';


/**
 * Apply fix for googles autocomplete
 */
export default class TouchFix extends FastClick {
  needsClick(t) {
    const { className = '' } = t;

    if (className.includes('pac-item')) {
      return true;
    }

    return super.needsClick(this, t);
  }
}



// WEBPACK FOOTER //
// ./src/lib/compat/ios/index.js